/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_NoInputs */

const en_ccsl_export_no = /** @type {(inputs: Ccsl_Export_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_ccsl_export_no = /** @type {(inputs: Ccsl_Export_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_ccsl_export_no = /** @type {(inputs: Ccsl_Export_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEIN`)
};

const it_ccsl_export_no = /** @type {(inputs: Ccsl_Export_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NO`)
};

const ru_ccsl_export_no = /** @type {(inputs: Ccsl_Export_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const es_ccsl_export_no = /** @type {(inputs: Ccsl_Export_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_cn2_ccsl_export_no = /** @type {(inputs: Ccsl_Export_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不`)
};

const ja_ccsl_export_no = /** @type {(inputs: Ccsl_Export_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const hi_ccsl_export_no = /** @type {(inputs: Ccsl_Export_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const pt_pt2_ccsl_export_no = /** @type {(inputs: Ccsl_Export_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Ccsl_Export_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_no = /** @type {((inputs?: Ccsl_Export_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_no(inputs)
	if (locale === "de") return de_ccsl_export_no(inputs)
	if (locale === "it") return it_ccsl_export_no(inputs)
	if (locale === "ru") return ru_ccsl_export_no(inputs)
	if (locale === "es") return es_ccsl_export_no(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_no(inputs)
	if (locale === "ja") return ja_ccsl_export_no(inputs)
	if (locale === "hi") return hi_ccsl_export_no(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_no(inputs)
	return en_ccsl_export_no(inputs)
});